// Import model
import { FilterProductItemRequest } from '../models/FilterProductItemRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ProductItemCondition } from '../models/ProductItemCondition';
import { ProductItemFields } from '../models/ProductItemFields';
import { ProductItemIndexedFields } from '../models/ProductItemIndexedFields';

// Import dependency serializers (for complex types)
import { ProductItemConditionSerializer } from './ProductItemConditionSerializer';
import { ProductItemFieldsSerializer } from './ProductItemFieldsSerializer';
import { ProductItemIndexedFieldsSerializer } from './ProductItemIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterProductItemRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterProductItemRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterProductItemRequest instance
   */
  static deserialize(json: string): FilterProductItemRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterProductItemRequest instance
   */
  static fromObject(obj: any): FilterProductItemRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterProductItemRequest');
    }


    const instance: FilterProductItemRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as ProductItemIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as ProductItemFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        ProductItemConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterProductItemRequest instances
   */
  static deserializeArray(json: string): FilterProductItemRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterProductItemRequest instance to a JSON string
   */
  static serialize(instance: FilterProductItemRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterProductItemRequest instance to a plain object
   */
  static toObject(instance: FilterProductItemRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        ProductItemConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterProductItemRequest instances to a JSON string
   */
  static serializeArray(instances: FilterProductItemRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
